import Message from './message.js'

let messageInstance
function getMessageInstance (options) {
    messageInstance = messageInstance || Message.newInstance(options)
    return messageInstance
}

function message (type, options) {
    let instance = getMessageInstance(options)
    const isString = typeof options === 'string'
    const closeable = !isString ? options.closeable || false : false
    const content = !isString ? options.content || '' : options
    const duration = !isString ? (options.duration === 0) ? 0 : options.duration || 4.5 : 4.5

    instance.message({
        type: type,
        closeable: closeable,
        content: content || '',
        duration: duration
    })
}

function destroy () {
    let instance = getMessageInstance()
    instance.destroy()
    messageInstance = null
}

export default {
    success (options) {
        return message('success', options)
    },
    warning (options) {
        return message('warning', options)
    },
    error (options) {
        return message('error', options)
    },
    destroy() {
        return destroy()
    }
}
